module.exports = __webpack_public_path__ + "static/media/stars-5.64883a01.svg";